import { createSelector } from 'reselect';
import { mapValues } from 'lodash-es';

import { ASSET, QV_TYPE } from '../configs/constants';
import { getQVTypeByKind, isDefaultQV, isFinanceQV } from '../utils';

const {
  performance,
  widgets,
  audience,
  aso,
  finance_performance,
  finance_widgets,
  forecasts,
  advanced_time_series,
  app_details,
  countries,
  publisher,
  sdks,
  time_series,
  top_apps,
  company_data,
  drivers,
  kpi_spotlight,
  mpi_spotlight,
  pub_contribution,
} = ASSET;

const getInitialDataStructure = (activeEntity, permissions) => {
  const entityType = getQVTypeByKind(activeEntity.kind);

  if (entityType === QV_TYPE.app) {
    if (isFinanceQV(permissions)) {
      return {
        [finance_performance]: {},
        [finance_widgets]: {
          finance_insights: {},
        },
        [forecasts]: {},
        [advanced_time_series]: {
          filters: {},
          cohorts: {},
        },
        [app_details]: {},
      };
    }

    return {
      [performance]: {
        time_series: {
          downloads: {},
        },
        country_breakdown: {
          downloads: [],
        },
      },
      [widgets]: {
        insights: {},
        ranks: {},
      },
      [audience]: {},
      [aso]: {
        organic: {},
        paid: {},
      },
      [app_details]: {},
    };
  }

  if (entityType === QV_TYPE.publisher) {
    return {
      [countries]: {},
      [publisher]: {},
      [sdks]: {},
      [time_series]: {},
      [top_apps]: {},
    };
  }

  if (entityType === QV_TYPE.company) {
    if (isFinanceQV(permissions)) {
      return {
        [company_data]: {},
        [drivers]: {},
        [kpi_spotlight]: {},
        [mpi_spotlight]: {},
      };
    }

    return {
      [company_data]: {},
      [drivers]: {},
      [pub_contribution]: {},
    };
  }

  return {};
};

const isQuickViewOpenSelector = state => state.isOpen;
const activeEntitySelector = state => state.activeEntity;
const quickViewSettingsSelector = state => state.settings;

const additionalParamsSelector = state => state.additionalParams;

const showBackBtnSelector = state => state.history.length > 1;

const permissionsSelector = state => state.permissions;
const isFinanceQVSelector = state => isFinanceQV(state.permissions);
const isDefaultQVSelector = state => isDefaultQV(state.permissions);

const quickViewDataSelector = createSelector(
  state => state.data,
  state => state.activeEntity,
  state => state.permissions,
  (data, activeEntity, permissions) => {
    if (!activeEntity) return {};

    const initialData = getInitialDataStructure(activeEntity, permissions);

    return mapValues(initialData, (assetData, asset) => (
      data[activeEntity.uniqKey]?.[asset] || assetData
    ));
  },
);

export {
  activeEntitySelector,
  isQuickViewOpenSelector,
  quickViewSettingsSelector,
  additionalParamsSelector,
  showBackBtnSelector,
  permissionsSelector,
  isFinanceQVSelector,
  isDefaultQVSelector,
  quickViewDataSelector,
};
